{
  "clear": "Törlés",
  "invalid": "(érvénytelen)",
  "loading": "Betöltés folyamatban…",
  "noResults": "Nincsenek találatok"
}
